import { Component } from '@angular/core';
import { DataService } from '../services/data.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-helcim',
  templateUrl: './helcim.component.html',
  styleUrls: ['./helcim.component.css'],
})
export class HelcimComponent {
  url: string = 'helcim';
  data: Array<any> = [];
  charges: Array<any> = [];
  payments: Array<any> = [];
  balances: Array<any> = [];
  customers: Array<any> = [];
  payouts: Array<any> = [];
  disputes: Array<any> = [];
  refunds: Array<any> = [];
  step = 4;
  currency = '';
  balance = 0;

  constructor(private dataService: DataService, private router: Router) {}

  ngOnInit(): void {
    this.getData();
  }

  getData(): void {
    this.dataService.getData(this.url).subscribe((response) => {
      console.log('response', response);

      if (response.rst) {
        this.data = response.data;
        this.charges = response.data.charges;
        this.payments = response.data.payments;
        this.balances = response.data.balance;
        this.customers = response.data.customers;
        this.currency = response.data.balance.available[0].currency;
        this.balance = response.data.balance.available[0].amount;
        this.payouts = response.data.payouts;
        this.disputes = response.data.disputes;
        this.refunds = response.data.refunds;
      }
    });
  }

  changeStep(step: number) {
    this.step = step;
  }

  getCustomerName(id: string): string {
    const cust = this.customers.find((p) => p.id === id);
    console.log('cust', cust);
    return cust ? cust.name + '(' + cust.email + ')' : 'Unknown';
  }
}
